import { rcTypeDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { MovementPatternConstant, movementPatternRequiredFieldList } from "presentation/constant/MovementPattern/MovementPatternConstant";
import { useMovementPatternVM } from "presentation/hook/MovementPattern/useMovementPatternVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { MovementPatternModel } from "presentation/model/MovementPattern/MovementPatternModel";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHBreadcrumb, HPHCheckbox, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, SidebarCaption, Sidebarheader, SidebarTitle, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const MovementPatternEditPanel = ({ movementPatternState }: { movementPatternState: MovementPatternModel }) => {
    const MOVEMENT_PATTERN_CONSTANT = MovementPatternConstant.Table;
    const [isLoading, setIsLoading] = useState(false);
    const movementPatternVM = useMovementPatternVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;
    const { currentRow, currentEditRow, isAdd, isEdit, isShowDtlAddPanel, isShowDtlEditPanel, masterState } = movementPatternState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();
    const panelRow = (isEdit || isAdd) ? currentEditRow : currentRow;

    const handleSave = useCallback(async () => {
        // if (!panelRow.patternType) {
        //     messageBarVM.showError("Pattern Type is mandatory.");
        //     return;
        // }
        // if (!panelRow.noOfLift) {
        //     messageBarVM.showError("Qty is mandatory.");
        //     return;
        // }
        // if (!panelRow.activeInd) {
        //     messageBarVM.showError("Active Ind is mandatory.");
        //     return;
        // }
        setIsLoading(true);
        movementPatternVM.onSaveClicked();
        const data = await movementPatternVM.onSave(panelRow);
        if (data && data.success) {
            messageBarVM.showSuccess("Save Successfully.");
            movementPatternVM.searchAllMovementPatternList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        } else {
            setIsLoading(false)
            data.data && messageBarVM.showError(data.data);
            return;
        }
    }, [movementPatternVM, panelRow, messageBarVM]);

    const handClose = useCallback(() => {
        movementPatternVM.onCloseEidtPanel();
    }, [movementPatternVM]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        movementPatternVM.onHeaderFieldChange(fieldName, fieldValue);
    }, [movementPatternVM]);

    const memoPatternType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "270px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={panelRow?.patternType || ''}
                fieldValue={panelRow?.patternType}
                fieldLabel={MOVEMENT_PATTERN_CONSTANT.PATTERN_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'patternType'}
                maxLength={60}
                options={rcTypeDropdownOption}
                requiredFieldList={movementPatternRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    movementPatternVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, panelRow?.patternType, MOVEMENT_PATTERN_CONSTANT.PATTERN_TYPE, isSaveClicked, movementPatternVM])


    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "270px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={movementPatternRequiredFieldList}
                fieldLabel={MOVEMENT_PATTERN_CONSTANT.ACTIVE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={panelRow?.activeInd === 'Y'}
                disabled={!(isAdd || isEdit)}
                onChange={(e) => movementPatternVM.onCheckboxChange(e.checked, "activeInd")}
            />
        </div>
        , [MOVEMENT_PATTERN_CONSTANT.ACTIVE_IND, panelRow?.activeInd, isAdd, isEdit, movementPatternVM])

    const memoChargeOnCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "270px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={panelRow?.chargeOnCompany || ''}
                fieldValue={panelRow?.chargeOnCompany}
                fieldLabel={MOVEMENT_PATTERN_CONSTANT.CHARGE_ON_COMPANY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeOnCompany'}
                maxLength={10}
                isLimitOptions={true}
                options={movementPatternState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={movementPatternRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    movementPatternVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, panelRow?.chargeOnCompany, MOVEMENT_PATTERN_CONSTANT.CHARGE_ON_COMPANY, isSaveClicked, movementPatternState.dynamicOptions.companyCodeDropdownOptions, movementPatternVM])

    const memoNoOfLift = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "250px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={MOVEMENT_PATTERN_CONSTANT.NO_LIFT}
                maxLength={10}
                width="250px"
                fieldName={"noOfLift"}
                value={panelRow?.noOfLift ?? ''}
                errorMessage={allFormState?.noOfLift}
                disabled={!(isAdd || isEdit)}
                decimalPlaces={0}
                optional={false}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [MOVEMENT_PATTERN_CONSTANT.NO_LIFT, panelRow?.noOfLift, allFormState, isAdd, isEdit, onNumberFieldChange])

    const handleEdit = useCallback(() => {
        movementPatternVM.onEditClick();
    }, [movementPatternVM]);

    const handleReset = useCallback(() => {
        movementPatternVM.onResetClick(isAdd);
    }, [movementPatternVM, isAdd]);


    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                {isLoading && <Loader Indicator="Spinner" size="Medium" />}
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: MovementPatternConstant.Title.CATEGORY },
                    { title: MovementPatternConstant.Title.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        {allowUpdate && (!(isAdd || isEdit)) && <NbisIconButton fileName='Icon-pen' size='medium' disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Edit'} onClick={handleEdit} />}
                        {(isAdd || isEdit) && <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />}

                        <IconButton fileName="Icon-cross" size="medium" disabled={(isShowDtlAddPanel || isShowDtlEditPanel)} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                        {(isAdd || isEdit) && <IconButton fileName="Icon-tick" size="medium" disabled={(isShowDtlAddPanel || isShowDtlEditPanel)} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'}>
                            <div className={'flex-row-item-stretch'}>
                                <SidebarTitle>
                                    {isAdd && "New movement Pattern"}
                                    {!isAdd && (panelRow.priority + "/" + panelRow.patternType)}
                                </SidebarTitle>
                                {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                            </div>
                        </div>

                        <CriteriaItemContainer>
                            {memoPatternType}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoChargeOnCompany}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoNoOfLift}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoActiveInd}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default memo(MovementPatternEditPanel);
